import { render, staticRenderFns } from "./EditorEditProjectItem.vue?vue&type=template&id=3c8c5d80&scoped=true&"
import script from "./EditorEditProjectItem.vue?vue&type=script&lang=js&"
export * from "./EditorEditProjectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8c5d80",
  null
  
)

export default component.exports